<template>
    <div class="bigWrapper">
        <div class="contentWrapper" v-if="!busyState">
            <div class="listWrap">
                <ul class="list">
                    <li v-for="property in properties">
                        <span class="boldTxt">{{ property.Label }} : </span> {{ property.Value }}
                    </li>
                </ul>
            </div>
            <div class="btnWrap">
                <b-button class="btnDashboard" variant="success"
                        v-b-tooltip.hover :title="$t('DisplayObject')"
                        @click="applySingleNode"> <!-- Affichage sur cet objet -->
                    <font-awesome-icon :icon="['fas', 'sheet-plastic']" size="sm" class="px-1" />
                </b-button>
            </div>
            <div class="rightBar"></div>
        </div>
        <div class="loaderWrapper" v-if="busyState">
            <b-spinner class="infoSpinner" label="Large Spinner" type="grow"></b-spinner>
            <b-spinner class="infoSpinner second" label="Large Spinner" type="grow"></b-spinner>
            <b-spinner class="infoSpinner third" label="Large Spinner" type="grow"></b-spinner>
        </div>
    </div>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
    import { Prop, Watch } from 'vue-property-decorator';
    import { namespace } from 'vuex-class';
    import MapLoader from './MapLoader.vue';

    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    // import NavBlock from '@/types/type-navBlock';
    import { ObjectUtils } from "@/components/commons/Utils";
    import { MAIN_FILTER_TREE } from '@/App.settings';
    import WorkingModeEnum from '@/enums/WorkingModeEnum';
    import locales from './locales/InfoWindowContent.json';

    library.add(faProjectDiagram);

    @Component({
        components: {
            FontAwesomeIcon,
            MapLoader
        },
        i18n : { messages : locales }
    })
    export default class InfoWindowContent extends mixins(ObjectUtils) {
        @Prop()
        private infoInvariant!: string;
        @Prop()
        private infoType!: string;
        @Prop()
        private infoNodeId!: string;

        mounted() {
            this.getNodeProps()
        }

        @Watch('infoNodeId')
        getNodeProps() {
            if (this.lastNode !== this.infoNodeId) {
                this.busyState = true
                this.$Direct.postAwaitable("carto/getNodeProps", { NodeId: this.infoNodeId, NodeType: this.infoType, NodeInvar: this.infoInvariant }).then((result) => {
                    this.properties = result;
                    this.busyState = false;
                    this.lastNode = this.infoNodeId;
                })
            }
        }

        private properties: object[] = [];
        private busyState: boolean = false;
        private lastNode: string | null = null;

        private async applySingleNode() {
            let node = this.$store.getters[MAIN_FILTER_TREE + "/Node"](this.infoNodeId);
            if (node) {
                await this.$store.dispatch("CartoMod/SetIsVisible", false); this.$store.dispatch('ToggleMode', WorkingModeEnum.Workbench);

                // Masquage la map et on place le node en SingleNode
                await this.$store.dispatch(MAIN_FILTER_TREE + "/SelectNode", { node: node, openNode: true, scrollIntoView: true });
                /** Passage en affichage */
                await this.$store.dispatch('SetDefaultFeature', {});
            }
        }
    }
</script>

<style scoped>
    .bigWrapper {
        position: relative;
        height: auto;
    }

    .contentWrapper {
        display: flex;
        justify-content: space-between;
        animation: grow-up 0.4s ease-out;
    }


    .listWrap {
        width: 90%;
        margin: 10px;
        max-height: 200px;
        overflow: auto;
        animation: slide-up 0.4s ease-out;
        scrollbar-width: thin;
    }

    .btnWrap {
        margin: 15px 5px;
        align-self: flex-end;
        animation: slide-up 0.4s ease-out;
    }

    .btnDashboard {
        border-radius: 50%;
        padding: 0.05rem 0.30rem;
        box-shadow: 2px 0 1px 0px rgba(0,0,0,0.5);
        background-color: #00B2BA !important;
        border-color: transparent !important;
    }

        .btnDashboard * {
            font-size: 11px;
        }

    .list {
        color: black;
        list-style-type: none;
        padding: 0px;
        text-align: left;
        margin: 0.5rem 0;
    }

    .boldTxt {
        font-weight: 200;
    }

    @keyframes slide-up {
        0% {
            opacity: 0;
            transform: translateY(25px)
        }

        100% {
            opacity: 1;
            transform: translateY(0)
        }
    }

    @keyframes grow-up {
        0% {
            max-height: 0px;
        }

        100% {
            max-height: 224px;
        }
    }

    .list li span {
        font-weight: bold;
    }

    .rightBar {
        position: absolute;
        top: -5px;
        right: -18px;
        background-color: #00506D;
        background-color: #7B9C23;
        width: 40px;
        height: 120%;
        transform: rotate(-4deg);
        z-index: -1;
        -webkit-box-shadow: inset 7px 0 9px -7px rgba(0,0,0,0.5);
        -moz-box-shadow: inset 7px 0 9px -7px rgba(0,0,0,0.5);
        box-shadow: inset 7px 0 9px -7px rgba(0,0,0,0.5);
    }

    .loaderWrapper {
        height: 50px;
        width: 75px;
        margin: auto;
        overflow: hidden;
    }


    .infoSpinner {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        display: block;
        width: 3rem;
        height: 3rem;
        animation-duration: 2000ms;
        animation-timing-function: ease-out;
    }

    .second {
        animation-delay: 500ms;
        animation-timing-function: ease-out;
        color: #93c01f;
    }

    .third {
        animation-delay: 1000ms;
        animation-timing-function: ease-out;
        color: #17a2b8;
    }
</style>